export var DEFAULT_SLIDE_ANIMATION_DURATION = 750;